import * as React from 'react';
import { IControl } from '@piceasoft/core';

export const ControlPivot: React.FC<IControl> = () => {
    return (
        <div>Overview</div>
    )
}
